export default {"src":"/_next/static/media/facebook.05785cc7.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};